<template>
  <layout-card-wrap
    v-loading="loading"
    hasSlot>
    <template slot="title">概况</template>
    <summary-list
      :list="list1"
      :span="8" />
    <summary-list
      :list="list2"
      :span="8" />
  </layout-card-wrap>
</template>

<script>
import SummaryList from './summary.vue'
import moment from 'moment'
export default {
  name: 'TrainData',
  components: { SummaryList },
  data() {
    return {
      loading: true,
      list1: [
        {
          label: '培训课程(家)',
          value: '0'
        },
        {
          label: '线上课程(种)',
          value: '0'
        },
        {
          label: '线下课程(条)',
          value: '0'
        }
      ],
      list2: [
        {
          label: '培训人次(家)',
          value: '0'
        },
        {
          label: '线上培训人次(家)',
          value: '0'
        },
        {
          label: '线下培训人次(人)',
          value: '0'
        }
      ]
    }
  },
  mounted() {
    this.getbasicdatastat()
  },
  methods: {
    getbasicdatastat() {
      this.loading = true
      this.$store.dispatch('account/gettrainingstat', {
        payload: {
          beginMonth: moment().format('YYYYMM'),
          endMonth: moment().format('YYYYMM')
        },
        success: (res) => {
          this.loading = false
          const data = res.data
          this.$set(this, 'list1', [
            {
              label: '培训课程(节)',
              value: data.totalTrainingCourseCount
            },
            {
              label: '线上课程(节)',
              value: data.totalOnlineTrainingCourseCount
            },
            {
              label: '线下课程(节)',
              value: data.totalOfflineTrainingCourseCount
            }
          ])
          this.$set(this, 'list2', [
            {
              label: '培训人次(人)',
              value: data.totalTrainingCount
            },
            {
              label: '线上培训人次(人)',
              value: data.totalOnlineTrainingCount
            },
            {
              label: '线下培训人次(人)',
              value: data.totalOfflineTrainingCount
            }
          ])
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
